import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/store";
import { ROUTES } from "@/lib/constants";
import type { UserRole } from "@/types";

interface RoleGuardProps {
  allowedRoles: UserRole[];
}

/** Restricts access to users whose role is in allowedRoles. */
export function RoleGuard({ allowedRoles }: RoleGuardProps) {
  const user = useAuthStore((s) => s.user);

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
}
